import { defineComponent, createBlock, openBlock, unref, normalizeClass, withCtx, createElementBlock, createCommentVNode, renderSlot } from "vue";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import _sfc_main$1 from "../../label/Label.js";
import { useFormField } from "./useFormField.js";
const _hoisted_1 = {
  key: 0,
  class: "mr-[-0.3rem] h-[0.55rem] text-(--red-9) leading-none"
}, _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormLabel",
  props: {
    class: {},
    required: { type: Boolean },
    for: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(__props) {
    const props = __props, formField = useFormField();
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), {
      class: normalizeClass(unref(cn)("data-[error=true]:text-(--red-9)", props.class)),
      for: unref(formField).formItemId,
      "data-slot": "form-label",
      "data-error": !!unref(formField).error.value
    }, {
      default: withCtx(() => [
        props.required ? (openBlock(), createElementBlock("span", _hoisted_1, "*")) : createCommentVNode("", !0),
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "for", "data-error"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormLabel.js.map
